import { initialAddTestValues } from './initialStatesValue';
import contentService from '../../../../../mylibrary/services/contentService';
export const handleOnChange = async (event: any, selectedTest: any, overAllData: any, props: any, setState: Function,handleDateError: Function) => {
    
    const { name, value } = event;
    let updatedSelectedTest = { ...selectedTest };
    let updatedPaperDetail: any = { ...selectedTest.paperDetail };
    switch (name) {
        case 'selectedTest':
            const selectedTestObject = { ...props.scheduledTestData.filter((test: any) => test.paperDetail.id === value)[0] };
            const updatedIsTestMapped = selectedTestObject.paperDetail ? selectedTestObject.paperDetail.id === '000000000000000000000000' ? false : true : false;
            if(updatedIsTestMapped){
               await setTestData(selectedTestObject.paperDetail.id, setState);
            }
            if (value) {
                updatedSelectedTest.paperDetail = selectedTestObject &&
                    selectedTestObject.paperDetail;
                updatedSelectedTest.displayName = selectedTestObject.displayName;
                updatedSelectedTest.syllabus = selectedTestObject
                    && selectedTestObject.paperDetail && selectedTestObject.paperDetail.syllabus
                    && selectedTestObject.paperDetail.syllabus.text;
                // updatedSelectedTest.paperDetail = updatedPaperDetail;
                updatedSelectedTest.duration = selectedTestObject.duration ? selectedTestObject.duration : '';
                updatedSelectedTest.maxAttempt = selectedTestObject.maxAttempt ? selectedTestObject.maxAttempt : '';
                updatedSelectedTest.scheduleDate = selectedTestObject.scheduleDate ? selectedTestObject.scheduleDate : new Date();
                // updatedSelectedTest.scheduleEndDate = selectedTestObject.scheduleEndDate ? selectedTestObject.scheduleEndDate : new Date();
                overAllData.name = selectedTestObject.displayName;
                overAllData.syllabus = selectedTestObject
                    && selectedTestObject.paperDetail
                    && selectedTestObject.paperDetail.syllabus.text;
                overAllData.duration = selectedTestObject.duration ? selectedTestObject.duration : '';
                overAllData.maxAttempts = selectedTestObject.maxAttempt ? selectedTestObject.maxAttempt : '';
                overAllData.startDate = selectedTestObject.scheduleDate ? selectedTestObject.scheduleDate : new Date();
                // overAllData.endDate = selectedTestObject.scheduleEndDate ? selectedTestObject.scheduleEndDate : '';
                overAllData.endDate = '';
                overAllData.testId = selectedTestObject
                    && selectedTestObject.paperDetail
                    && selectedTestObject.paperDetail.id
                overAllData.scheduleID = selectedTestObject.scheduleID;
                overAllData.type = selectedTestObject
                    && selectedTestObject.paperDetail
                    && selectedTestObject.paperDetail.type;
                overAllData.revisionTime = selectedTestObject.revisionTime ? selectedTestObject.revisionTime : '';
                
            } else {
                let courseId = updatedSelectedTest.courseId;
                updatedSelectedTest = initialAddTestValues.selectedTest;
                updatedSelectedTest.courseId = courseId;
                
            }
            handleDateError(updatedSelectedTest, overAllData);
            setState({
                selectedTest: JSON.parse(JSON.stringify(updatedSelectedTest)),
                isTestMapped: updatedIsTestMapped,
                overAllData
            });
            break;
        case 'testName':
            updatedSelectedTest.displayName = value;
            overAllData.name = value;
            updatedSelectedTest.paperDetail.name = value
            setState({
                selectedTest: updatedSelectedTest,
                overAllData
            })
            break;
        case 'testSyllabus':
            let newPaperDetail = { ...updatedSelectedTest.paperDetail }
            newPaperDetail.syllabus = value;
            updatedSelectedTest.paperDetail = newPaperDetail;
            overAllData.syllabus = value;
            setState({
                selectedTest: updatedSelectedTest,
                overAllData
            })
            break;
        case 'duration':
            updatedSelectedTest.duration = value;
            overAllData.duration = value;
            updatedSelectedTest.paperDetail.duration = value;
            setState({
                selectedTest: updatedSelectedTest,
                overAllData
            })
            break;
        case 'blockRevisionTime':
            updatedSelectedTest.blockRevisionTime = value;
            overAllData.revisionTime = value;
            updatedSelectedTest.paperDetail.blockRevisionTime = value;
            setState({
                selectedTest: updatedSelectedTest,
                overAllData,
            })
            break;
        case 'maxAttempt':
            updatedSelectedTest.maxAttempt = value;
            overAllData.maxAttempts = value;
            updatedSelectedTest.paperDetail.maxAttempt = value;
            setState({
                selectedTest: updatedSelectedTest,
                overAllData
            })
            break;
        case 'questionsCount':
            updatedSelectedTest.questionsCount = +value;
            overAllData.questionsCount = value;
            setState({
                selectedTest: updatedSelectedTest,
                overAllData
            })
    
            break;
        default:
    }
}

export const setTestData = async (testId: string, handleSetState: Function) => {
    // await contentService.details(`${testId}testpapers`).then((res: any) => {
    //     const { title, contentId } = res;
    //     handleSetState({ mapTestName: `${contentId}| ${title}` });
    // });
    const res = await contentService.detailsNTL(`${testId}testpapers`);
    const { title, contentId } = res;
    handleSetState({ mapTestName: `${contentId}| ${title}` });
}